import React, { useState, useEffect } from "react";
import { Box, Tooltip } from "@mui/material";

const PokemonSprite = ({ pokemon, size = 40, style, fainted = false }) => {
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    const getPokemonSprite = (pokemonName) => {
      if (!pokemonName) return null;
      
      // Mapa de nombres especiales que requieren formateo específico
      const specialNames = {
        'Urshifu-Rapid-Strike': 'urshifu-rapidstrike',
        'urshifu-rapid-strike': 'urshifu-rapidstrike',
        'Chien-Pao': 'chienpao',
        'chien-pao': 'chienpao',
        'Chi-Yu': 'chiyu',
        'chi-yu': 'chiyu',
        'Ting-Lu': 'tinglu',
        'ting-lu': 'tinglu',
        'Wo-Chien': 'wochien',
        'wo-chien': 'wochien',
        'Ho-Oh': 'hooh',
        'Necrozma-Dawn-Wings': 'necrozma-dawnwings',
        'Necrozma-Dusk-Mane': 'necrozma-duskmane',
        'Toxtricity-Low-Key': 'toxtricity-lowkey',
        'Kommo-o': 'kommoo',
        'Porygon-Z': 'porygonz',
        'Tauros-Paldea-Blaze': 'tauros-paldeablaze',
        'Tauros-Paldea-Aqua': 'tauros-paldeaaqua',
        'Tauros-Paldea-Combat': 'tauros-paldeacombat',
      };

      // Comprobar si es un caso especial
      const formattedName = specialNames[pokemonName] ||
                           pokemonName.toLowerCase()
                                    .replace(/\s+/g, '')
                                    .replace(/[^a-z0-9-]/g, '');

      // Intenta primero con los sprites animados
      const animatedUrl = `https://play.pokemonshowdown.com/sprites/gen5ani/${formattedName}.gif`;
      const staticUrl = `https://play.pokemonshowdown.com/sprites/gen5/${formattedName}.png`;
    
      const dexUrl = `https://play.pokemonshowdown.com/sprites/dex/${formattedName}.png`;

      return new Promise((resolve) => {
        const animatedImg = new Image();
        animatedImg.onload = () => resolve(animatedUrl);
        animatedImg.onerror = () => {
          const staticImg = new Image();
          staticImg.onload = () => resolve(staticUrl);
          staticImg.onerror = () => {
            const dexImg = new Image();
            dexImg.onload = () => resolve(dexUrl);
            dexImg.onerror = () => {
              resolve(pokemon?.sprite || pokemon?.officialArtwork || null);
            };
            dexImg.src = dexUrl;
          };
          staticImg.src = staticUrl;
        };
        animatedImg.src = animatedUrl;
      });
    };

    if (pokemon?.name) {
      getPokemonSprite(pokemon.name).then(url => setImgSrc(url));
    }
  }, [pokemon?.name, pokemon?.sprite, pokemon?.officialArtwork]);

  return (
    <Tooltip title={pokemon?.name || "Unknown"} arrow>
      <Box
        role="img"
        aria-label={pokemon?.name || "Unknown Pokémon"}
        sx={{ position: 'relative', width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }}
      >
        {/* Image — grayscale/opacity only applied here so the X overlay is unaffected */}
        <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: fainted ? 0.35 : 1, filter: fainted ? 'grayscale(1)' : 'none' }}>
          {pokemon?.name && imgSrc ? (
            <img
              src={imgSrc}
              alt=""
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              onError={(e) => {
                e.target.onerror = null;
                const parent = e.target.parentNode;
                const textElement = document.createElement('span');
                textElement.textContent = pokemon.name;
                textElement.style.fontSize = '12px';
                textElement.style.textAlign = 'center';
                textElement.style.wordBreak = 'break-word';
                parent.replaceChild(textElement, e.target);
              }}
            />
          ) : (
            <Box sx={{ width: 24, height: 24, borderRadius: '50%', border: '2px solid #000000', backgroundColor: 'transparent' }} />
          )}
        </Box>
        {fainted && (
          <Box sx={{
            position: 'absolute', inset: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#ff4444', fontWeight: 900, fontSize: `${size * 0.5}px`, lineHeight: 1,
            textShadow: '0 0 4px #000', pointerEvents: 'none',
          }}>
            ✕
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default PokemonSprite;